<template>
  <div class="severity-chip" :style="{ backgroundColor: bgColor, color: color }">
    {{ label }}
  </div>
</template>

<script>
import { getSeverityColor, getSeverityBgColor, getSeverityInfo } from '@/services/entra-utils.js';

export default {
  name: 'FindingSeverityChip',
  props: {
    severity: { type: String, default: 'medium' }
  },
  computed: {
    info: function() { return getSeverityInfo(this.severity); },
    label: function() { return this.info.label; },
    color: function() { return getSeverityColor(this.severity); },
    bgColor: function() { return getSeverityBgColor(this.severity); }
  }
};
</script>

<style scoped>
.severity-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
